@if (!isInEventSetup && !onlyForm) {
  <div class="header-page mb-2">
    @if (id === 0) {
      {{ 'settlementaccount.header_add_account' | translate }}
    } @else {
      {{ 'settlementaccount.header_edit_account' | translate }}
    }
  </div>

  <app-back-to-list [routerLink]="'/organizers/accounts'" />
}

<div [class.mt-10]="!onlyForm">
  @if (isAdyenRouted) {
    <div class="flex items-center gap-2 p-4 mb-4 bg-[#fef9e4] rounded-lg border border-emerald-200 w-full md:w-3/4">
      <mat-icon>info</mat-icon>
      <span>{{ adyenManagedNotice }}</span>
      <a [routerLink]="['/organizers/profile']" class="whitespace-nowrap underline">
        {{ adyenManagedNoticeLink }}
      </a>
    </div>
  }
  @if (!accessDenied) {
    <div [formGroup]="accountFormGroup" class="flex flex-col gap-2">
      @if (needIdentityValidation) {
        <app-organizer-validation
          [organizerId]="userData.clubId"
          [shownInEventSetup]="isInEventSetup"
          (shouldMoveToValidationUrl)="onShouldMoveToValidationUrl($event)"
          (validationCompleted)="onIdentityValidationCompleted()"></app-organizer-validation>
      } @else {
        @if (hasSettlementAccountValidation) {
          @if (needSettlementAccountValidation) {
            <div class="p-4 py-6 mt-1 mb-6 bg-[#fef9e4] rounded-lg border border-emerald-200 w-full md:w-3/4 lg:1/2">
              <div class="text-xl font-semibold mb-2">
                {{ 'settlementaccount.validation.validate-account-need-validation-header' | translate }}
              </div>

              <div class="flex items-center gap-2">
                <i class="fa-light fa-triangle-exclamation text-orange-600 text-2xl"></i>
                <div class="pl-2">
                  <p [innerHTML]="'settlementaccount.validation.validate-account-need-validation-text' | translate"></p>
                </div>
              </div>
              <div class="mt-8">
                <a
                  target="_blank"
                  [routerLink]="['/organizers/accounts/' + uniqueId + '/validate']"
                  class="button-regular">
                  {{ 'settlementaccount.validation.validate-account-need-validation-button' | translate }}
                </a>
              </div>
            </div>
          } @else {
            <div class="inline-flex">
              <div class="flex items-center bg-green-50 border border-green-200 rounded-lg mb-6 px-2 py-1">
                <i class="fa-solid fa-shield-check text-green-500 mr-2"></i>
                <span class="text-green-800 font-medium">Konto er validert</span>
              </div>
            </div>
          }
        }

        @let accountCtrl = accountFormGroup.controls['account'];
        @let sortcodeCtrl = accountFormGroup.controls['sortcode'];

        <mat-form-field class="input_w-full no-padding-mat-field" appearance="outline">
          <mat-label>{{ 'settlementaccount.account' | translate }}</mat-label>
          <input matInput maxlength="41" formControlName="account" [required]="true" />

          @if (accountCtrl.errors?.pattern) {
            <mat-error> {{ 'validation.only_numbers' | translate }}</mat-error>
          }

          @if (
            (accountFormGroup.hasError('minlength', 'account') || accountFormGroup.hasError('maxlength', 'account')) &&
            !accountCtrl.errors?.pattern
          ) {
            <mat-error> {{ 'validation.invalid.length' | translate }}</mat-error>
          }
        </mat-form-field>

        @if (showGeoSpecificControlsUK) {
          <span>
            <mat-form-field class="input_w-full no-padding-mat-field" appearance="outline">
              <mat-label>{{ 'settlementaccount.sortcode' | translate }}</mat-label>
              <input matInput maxlength="50" formControlName="sortcode" [required]="true" />

              @if (sortcodeCtrl.errors?.pattern) {
                <mat-error>{{ 'validation.only_numbers' | translate }} </mat-error>
              }

              @if (
                (accountFormGroup.hasError('minlength', 'sortcode') ||
                  accountFormGroup.hasError('maxlength', 'sortcode')) &&
                !sortcodeCtrl.errors?.pattern
              ) {
                <mat-error> {{ 'validation.invalid.length' | translate }}</mat-error>
              }
            </mat-form-field>
          </span>
        }

        <mat-form-field class="input_w-full no-padding-mat-field" appearance="outline">
          <mat-label>{{ 'settlementaccount.owner' | translate }}</mat-label>
          <input matInput maxlength="100" formControlName="name" [required]="true" />
        </mat-form-field>

        @if (showDefaultCheckbox) {
          <span>
            <mat-checkbox formControlName="isDefault">{{
              'settlementaccount.isdefaultaccount' | translate
            }}</mat-checkbox>
          </span>
        }

        @if (bufferModuleEnabled && !isInEventSetup && !onlyForm && adyenGateResolved && !isAdyenRouted) {
          <div class="my-4">
            <app-account-buffer-edit
              [accountId]="id"
              [currentBufferAmount]="currentBufferAmount"
              [targetBufferAmount]="targetBufferAmount"
              [bufferAccountActivated]="isBufferAccountActivated"
              [isEditMode]="isEditMode"
              (bufferChanged)="OnBufferUpdated($event)"
              (requestSave)="updateAccount()"></app-account-buffer-edit>
          </div>
        }

        @if (!onlyForm && adyenGateResolved && !isAdyenRouted) {
          <div>
            @if (this.isEditMode) {
              <button
                class="button-outline-warning mt-16"
                [disabled]="!canSave || isLoading"
                type="button"
                (click)="deleteAccount()">
                {{ 'global.delete' | translate }}
              </button>
            } @else {
              <button
                class="button-regular"
                [disabled]="!accountFormGroup.valid || isLoading || !accountFormGroup.dirty || !canSave"
                type="button"
                (click)="updateAccount()">
                <span>{{ 'global.add' | translate }}</span>
              </button>
            }
          </div>
        }
      }

      @if (accessDenied && !isLoading) {
        <div>
          <div>
            <mat-icon>info</mat-icon>
          </div>
          <div style="padding-left: 10px" [innerHTML]="'validation.no_access' | translate"></div>
        </div>
      }
    </div>
  }
</div>
